<div
  class="flex flex-col gap-2 p-2"
  (click)="$event.stopPropagation()"
  (keydown)="$event.stopPropagation()"
>
  <p-selectbutton
    [options]="modeOptions"
    [ngModel]="mode()"
    (onChange)="onModeChange($event.value)"
    optionLabel="label"
    optionValue="value"
    [unselectable]="true"
    size="small"
  >
    <ng-template #item let-item>{{ item.label | translate }}</ng-template>
  </p-selectbutton>

  @if (mode() === 'address') {
    <p-iconfield iconPosition="left" class="w-full">
      <input
        pInputText
        type="text"
        class="w-full"
        [ngModel]="query()"
        (ngModelChange)="onQueryInput($event)"
        [placeholder]="'formly.address_search.placeholder' | translate"
      />
      <p-inputicon>
        <i class="fas fa-search"></i>
      </p-inputicon>
    </p-iconfield>

    @if (loading()) {
      <div class="flex items-center gap-2 text-sm text-color-secondary py-1">
        <p-progress-spinner ariaLabel="loading" [style]="{ width: '18px', height: '18px' }" />
        {{ 'formly.address_search.searching' | translate }}
      </div>
    } @else if (placesUnavailable()) {
      <div class="text-sm text-color-secondary py-1">
        {{ 'formly.address_search.unavailable' | translate }}
      </div>
    } @else if (!resolved() && query().trim().length >= 3 && suggestions().length === 0) {
      <div class="text-sm text-color-secondary py-1">
        {{ 'formly.address_search.no_suggestions' | translate }}
      </div>
    } @else if (suggestions().length > 0) {
      <ul class="flex flex-col max-h-48 overflow-auto">
        @for (suggestion of suggestions(); track suggestion.placeId) {
          <li
            class="px-2 py-1.5 cursor-pointer hover:bg-surface-100 rounded text-sm"
            (click)="onSuggestionClick(suggestion)"
          >
            {{ suggestion.descrizione }}
          </li>
        }
      </ul>
    }
  }
</div>
